import { IconProps } from './IconProps';

export const Support = (props: IconProps) => {
  return (
    <svg
    className={props.className}
    style={props.style}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.375 5.7725V5H14.0625C14.4423 5 14.75 4.70167 14.75 4.33333V3.66667C14.75 3.29833 14.4423 3 14.0625 3H9.9375C9.55766 3 9.25 3.29833 9.25 3.66667V4.33333C9.25 4.70167 9.55766 5 9.9375 5H10.625V5.7725C5.96246 6.42125 2.375 10.2992 2.375 15H21.625C21.625 10.2992 18.0375 6.42125 13.375 5.7725ZM22.3125 16.3333H1.6875C1.30766 16.3333 1 16.6317 1 17V18.3333C1 18.7017 1.30766 19 1.6875 19H22.3125C22.6923 19 23 18.7017 23 18.3333V17C23 16.6317 22.6923 16.3333 22.3125 16.3333Z"
        fill="black"
      />
    </svg>
  );
};
